module.exports = __webpack_public_path__ + "static/img/shadow.6f18c91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/shadow.png
// module id = qWnl
// module chunks = 0